import React, { Component } from "react";
import { Api } from "../utils/api";
import { withRouter } from "react-router";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import moment from "moment";
import Paper from "@material-ui/core/Paper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";

import NewRequests from "./charts/pie-new-requests";
import NewCalls from "./charts/pie-new-calls";
import RequestStates from "./charts/bar-req-states";
import FollowUpTypes from "./charts/bar-followup-types";
import ReqNotAccepted from "./charts/pie-req-notaccepted";
import PendingReq from "./charts/pie-pending-req";
import StandByReq from "./charts/pie-standby-req";
import CallRegistsOtherCalls from "./charts/bar-call-regists-other-calls";
import AdmissionsReq from "./charts/bar-admissions";
import FollowupsVsAdmissions from "./charts/radial-followups-vs-admissions";
import AdmissionsPaidVsNotPaid from "./charts/pie-admissionspaid-vs-notpaid";
import FollowupsBySocialWorker from "./charts/bar-followups-by-social-worker";
import { NewRequestsFilterForm } from "./forms/new-requests.filter.form";
import { RequestStatesFilterForm } from "./forms/request-states.filter.form";
import { FollowUpTypesFilterForm } from "./forms/followup-types.filter.form";
import { PieReqSliderFilterForm } from "./forms/pie-req-slider.filter.form";
import { OtherCallsFilterForm } from "./forms/other-calls.filter.form";
import { AdmissionsFilterForm } from "./forms/admissions.filter.form";
import { AdmissionsPaidVsNotPaidFilterForm } from "./forms/admissionspaid-vs-notpaid.filter.form";
import { FollowupsVsAdmissionsFilterForm } from "./forms/followups-vs-admissions.filter.form";
import ReactSlidy from "react-slidy";
import "react-slidy/lib/styles.css";

class StatisticsView extends Component {
  constructor() {
    super();
    this.api = new Api();
    this.user = localStorage.getItem("id");
    this.renderProgress = this.renderProgress.bind(this);
    this.countFollowupsBySocialWorker =
      this.countFollowupsBySocialWorker.bind(this);
    this.countNewRequests = this.countNewRequests.bind(this);
    this.countCalls = this.countCalls.bind(this);
    this.countRequestStates = this.countRequestStates.bind(this);
    this.countFollowUpTypes = this.countFollowUpTypes.bind(this);
    this.countReqNotAccepted = this.countReqNotAccepted.bind(this);
    this.countPendingReq = this.countPendingReq.bind(this);
    this.countStandByReq = this.countStandByReq.bind(this);
    this.countCallRegistsOtherCalls =
      this.countCallRegistsOtherCalls.bind(this);
    this.countAdmissions = this.countAdmissions.bind(this);
    this.countFollowupsVsAdmissions =
      this.countFollowupsVsAdmissions.bind(this);
    this.countAdmissionsPaidVsNotPaid =
      this.countAdmissionsPaidVsNotPaid.bind(this);
  }

  state = {
    showLoading: false,
    followUps: null,
    newRequests: null,
    newCalls: null,
    requestStates: null,
    followUpTypes: null,
    reqNotAccepted: null,
    pendingReq: null,
    standByReq: null,
    callRegistsOtherCalls: null,
    admissions: null,
    followupsVsAdmissions: null,
    admissionsPaidVsNotPaid: null,
    filter_date_new_requests: null,
    filter_date_request_states: null,
    filter_date_followup_types: null,
    filter_slider: null,
    filter_date_other_calls: null,
    filter_date_admissions: null,
    filter_date_admissions_paid_vs_not_paid: null,
    filter_date_followups_vs_admissions: null,
  };

  componentDidMount() {
    let date_begin = "";
    let date_end = "";

    this.countFollowupsBySocialWorker({ date_begin, date_end });
    this.countNewRequests({ date_begin, date_end });
    this.countCalls({ date_begin, date_end });
    this.countRequestStates({ date_begin, date_end });
    this.countFollowUpTypes({ date_begin, date_end });
    this.countReqNotAccepted({ date_begin, date_end });
    this.countPendingReq({ date_begin, date_end });
    this.countStandByReq({ date_begin, date_end });
    this.countCallRegistsOtherCalls({ date_begin, date_end });
    this.countAdmissions({ date_begin, date_end });
    this.countFollowupsVsAdmissions({ date_begin, date_end });
    this.countAdmissionsPaidVsNotPaid({ date_begin, date_end });
  }

  //circulo de loading para 1º grafico
  renderProgress() {
    if (this.state.showLoading) this.setState({ showLoading: false });
    else this.setState({ showLoading: true });
  }

  /* FILTRO DATAS dos 2 Graficos de Pedidos Novos */
  filterDateNewRequests = (info) => {
    this.setState({ filter_date_new_requests: info.date_since });
  };

  /* FILTRO DATAS do Pedidos por estado */
  filterDateRequestStates = (info) => {
    this.setState({ filter_date_request_states: info.date_since });
  };

  /* FILTRO DATAS Acompanhamentos */
  filterDateFollowUpTypes = (info) => {
    this.setState({ filter_date_followup_types: info.date_since });
  };

  /* FILTRO DATAS Slider - 3 graficos pedidos sem resoluçao */
  filterDateNoResolution = (info) => {
    this.setState({ filter_slider: info.date_since });
  };

  /* FILTRO DATAS Leads sem conversao */
  filterDateOtherCalls = (info) => {
    this.setState({ filter_date_other_calls: info.date_since });
  };

  /* FILTRO DATAS Admissões */
  filterDateAdmissions = (info) => {
    this.setState({ filter_date_admissions: info.date_since });
  };

  /* FILTRO DATAS Admissões- face aos encaminhados */
  filterDateFollowupsVsAdmissions = (info) => {
    this.setState({ filter_date_followups_vs_admissions: info.date_since });
  };

  /* FILTRO DATAS Admissions vs followups */
  filterDateAdmissionsPaidVsNotPaid = (info) => {
    this.setState({ filter_date_admissions_paid_vs_not_paid: info.date_since });
  };

  /* GET GRAF RESUMO DE ENCAMINHAMENTOS POR ASSIST SOCIAL*/
  countFollowupsBySocialWorker = (info) => {
    let date_begin = info.date_since
      ? info.date_since
      : moment().startOf("month").format("YYYY-MM-DD");
    let date_end = info.date_until
      ? info.date_until
      : moment().endOf("month").format("YYYY-MM-DD");
    this.renderProgress();
    this.api
      .get("/statistics", {
        type: "followups_by_social_worker",
        date_begin,
        date_end,
      })
      .then(({ data = null }) => {
        this.setState({ followUps: data });
        this.renderProgress();
      });
  };

  /* GET GRAF REGISTO DE PEDIDOS NOVOS - FORM DE AJUDA*/
  countNewRequests = (info) => {
    let date_begin =
      info.date_begin !== ""
        ? moment(info.date_since).format("YYYY-MM-DD")
        : "";
    let date_end =
      info.date_end !== ""
        ? moment(info.date_until).add("days", 1).format("YYYY-MM-DD")
        : "";
    this.api
      .get("/statistics", { type: "pie_new_requests", date_begin, date_end })
      .then(({ data = null }) => {
        this.setState({ newRequests: data });
      });
  };

  /* GET GRAF ATENDIMENTO*/
  countCalls = (info) => {
    let date_begin =
      info.date_begin !== ""
        ? moment(info.date_since).format("YYYY-MM-DD")
        : "";
    let date_end =
      info.date_end !== ""
        ? moment(info.date_until).add("days", 1).format("YYYY-MM-DD")
        : "";
    this.api
      .get("/statistics", { type: "pie_new_calls", date_begin, date_end })
      .then(({ data = null }) => {
        this.setState({ newCalls: data });
      });
  };

  /* GET GRAF PEDIDOS POR ESTADO*/
  countRequestStates = (info) => {
    let date_begin = moment(info.date_since).format("YYYY-MM-DD");
    let date_end = moment(info.date_until).add("days", 1).format("YYYY-MM-DD");
    this.api
      .get("/statistics", { type: "bar_request_states", date_begin, date_end })
      .then(({ data = null }) => {
        this.setState({ requestStates: data });
      });
  };

  /* GET GRAF TIPOS DE PEDIDOS ACEITES*/
  countFollowUpTypes = (info) => {
    let date_begin = moment(info.date_since).format("YYYY-MM-DD");
    let date_end = moment(info.date_until).add("days", 1).format("YYYY-MM-DD");
    this.api
      .get("/statistics", { type: "bar_followup_types", date_begin, date_end })
      .then(({ data = null }) => {
        this.setState({ followUpTypes: data });
      });
  };

  /* GET GRAF PEDIDOS ENCAMINHADOS E NAO ACEITES*/
  countReqNotAccepted = async (info) => {
    let date_begin =
      info.date_begin !== ""
        ? moment(info.date_since).format("YYYY-MM-DD")
        : "";
    let date_end =
      info.date_end !== ""
        ? moment(info.date_until).add("days", 1).format("YYYY-MM-DD")
        : "";
    this.api
      .get("/statistics", {
        type: "pie_req_not_accepted",
        date_begin,
        date_end,
      })
      .then(({ data = null }) => {
        this.setState({ reqNotAccepted: data });
      });
  };

  /* GET GRAF PENDENTES*/
  countPendingReq = (info) => {
    let date_begin =
      info.date_begin !== ""
        ? moment(info.date_since).format("YYYY-MM-DD")
        : "";
    let date_end =
      info.date_end !== ""
        ? moment(info.date_until).add("days", 1).format("YYYY-MM-DD")
        : "";
    this.api
      .get("/statistics", { type: "pie_pending_req", date_begin, date_end })
      .then(({ data = null }) => {
        this.setState({ pendingReq: data });
      });
  };

  /* GET GRAF STAND-BY*/
  countStandByReq = (info) => {
    let date_begin =
      info.date_begin !== ""
        ? moment(info.date_since).format("YYYY-MM-DD")
        : "";
    let date_end =
      info.date_end !== ""
        ? moment(info.date_until).add("days", 1).format("YYYY-MM-DD")
        : "";
    this.api
      .get("/statistics", { type: "pie_standby_req", date_begin, date_end })
      .then(({ data = null }) => {
        this.setState({ standByReq: data });
      });
  };

  /* GET GRAF Leads sem conversão */
  countCallRegistsOtherCalls = (info) => {
    let date_begin = info.date_since
      ? info.date_since
      : moment().startOf("month").format("YYYY-MM-DD");
    let date_end = info.date_until
      ? info.date_until
      : moment().endOf("month").format("YYYY-MM-DD");
    this.api
      .get("/statistics", {
        type: "pie_call_regists_other_calls",
        date_begin,
        date_end,
      })
      .then(({ data = null }) => {
        this.setState({ callRegistsOtherCalls: data });
      });
  };

  /* GET GRAF ADMISSOES*/
  countAdmissions = (info) => {
    let date_begin = info.date_since
      ? moment(info.date_since).format("YYYY-MM-DD")
      : "";
    let date_end = info.date_until
      ? moment(info.date_until)
          .add(info.date_until)
          .add("days", 1)
          .format("YYYY-MM-DD")
      : "";
    this.api
      .get("/statistics", { type: "bar_admissions", date_begin, date_end })
      .then(({ data = null }) => {
        this.setState({ admissions: data });
      });
  };

  /* GET GRAF ADMISSOES FACE AOS ENCAMINHAMENTOS*/
  countFollowupsVsAdmissions = (info) => {
    let date_begin = info.date_since
      ? moment(info.date_since).format("YYYY-MM-DD")
      : "";
    let date_end = info.date_until
      ? moment(info.date_until)
          .add(info.date_until)
          .add("days", 1)
          .format("YYYY-MM-DD")
      : "";
    this.api
      .get("/statistics", {
        type: "radial_followups_vs_admissions",
        date_begin,
        date_end,
      })
      .then(({ data = null }) => {
        this.setState({ followupsVsAdmissions: data });
      });
  };

  /* GET GRAF ADMISSOES FACE AOS ENCAMINHAMENTOS*/
  countAdmissionsPaidVsNotPaid = (info) => {
    let date_begin = info.date_since
      ? moment(info.date_since).format("YYYY-MM-DD")
      : "";
    let date_end = info.date_until
      ? moment(info.date_until)
          .add(info.date_until)
          .add("days", 1)
          .format("YYYY-MM-DD")
      : "";
    this.api
      .get("/statistics", {
        type: "radial_admissions_paid_vs_not_paid",
        date_begin,
        date_end,
      })
      .then(({ data = null }) => {
        this.setState({ admissionsPaidVsNotPaid: data });
      });
  };

  render() {
    return (
      <div class="container mt-4">
        <Grid container spacing={3}>
          <Grid item md={12}>
            <div class="indice_stats">
              <Button
                href="#geral"
                style={{ width: "130px" }}
                variant="contained"
                color="primary"
              >
                1. Geral
              </Button>
              <Button
                href="#pedidos"
                style={{ width: "130px" }}
                variant="contained"
                color="primary"
              >
                2. Pedidos
              </Button>
              <Button
                href="#admissoes"
                style={{ width: "130px" }}
                variant="contained"
                color="primary"
              >
                3. Admissões
              </Button>
            </div>
          </Grid>

          <Grid item xs={12}>
            <h1 class="h3 statistics-title" id="geral">
              1. Geral
            </h1>
          </Grid>

          {/*////// GRAF RESUMO MENSAL DOS ENCAMINHAMENTOS  ////*/}
          <Grid item xs={12}>
            <div class="statistics-followups-workers">
              <FollowupsBySocialWorker followUps={this.state.followUps} />
              <div class="text-center" hidden={!this.state.showLoading}>
                <CircularProgress color="primary" />
              </div>
            </div>
          </Grid>

          <Grid item xs={12}>
            <h1 class="h3 statistics-title" id="pedidos">
              2. Pedidos
            </h1>
            {/*///////////// Filtro datas 2 Graficos de Pedidos Novos  ////////////*/}
            <NewRequestsFilterForm
              filterDateNewRequests={this.filterDateNewRequests}
              countNewRequests={this.countNewRequests}
              countCalls={this.countCalls}
            />
          </Grid>

          {/*///////////// GRAF Registo de Pedidos Novos - Formulário de Ajuda  ////////////*/}
          <Grid item xs={6}>
            <div>
              <NewRequests newRequests={this.state.newRequests} />
            </div>
          </Grid>

          {/*/////////////// GRAF Atendimento  ///////////////*/}
          <Grid item xs={6}>
            <div>
              <NewCalls newCalls={this.state.newCalls} />
            </div>
          </Grid>

          {/*///// Soma dos Pedidos por Atribuir do BO + Pedidos Novos das Tipificações  /////*/}
          <Grid item xs={12}>
            {this.state.newRequests && this.state.newCalls && (
              <div class="h5 mt-4 text-center ">
                <Paper elevation={5}>
                  <div class="text-primary">
                    <br />
                    <span class="pl-4 pr-4 h1">
                      <FontAwesomeIcon icon={faChartLine} />
                    </span>
                    <span class="pl-4 pr-4 h1">
                      {this.state.newRequests[0].todays_new_requests +
                        this.state.newCalls[0].requests}
                    </span>
                    Pedidos novos
                    <br />
                    <br />
                  </div>
                </Paper>
              </div>
            )}
          </Grid>

          {/*/////////////// GRAF Pedidos - por estado  ///////////////*/}
          <Grid item xs={6}>
            {/*// filtro datas do grafico pedidos por estado //*/}
            <RequestStatesFilterForm
              filterDateRequestStates={this.filterDateRequestStates}
              countRequestStates={this.countRequestStates}
            />
            <div class="req-states">
              <RequestStates
                filter_date={this.state.filter_date_request_states}
                requestStates={this.state.requestStates}
              />
            </div>
          </Grid>

          {/*/////////////// GRAF ACOMPANHAMENTOS  ///////////////*/}
          <Grid item xs={6}>
            {/*// filtro datas do grafico acompanhamentos //*/}
            <FollowUpTypesFilterForm
              filterDateFollowUpTypes={this.filterDateFollowUpTypes}
              countFollowUpTypes={this.countFollowUpTypes}
            />
            <div>
              <FollowUpTypes
                filter_date_followup_types={
                  this.state.filter_date_followup_types
                }
                followUpTypes={this.state.followUpTypes}
              />
            </div>
          </Grid>

          <Grid class="slide_grafs" item xs={6}>
            <PieReqSliderFilterForm
              filterDateNoResolution={this.filterDateNoResolution}
              countReqNotAccepted={this.countReqNotAccepted}
              countPendingReq={this.countPendingReq}
              countStandByReq={this.countStandByReq}
            />

            <div class="graf_titulo">
              <strong>Pedidos sem resolução</strong>
            </div>
            <ReactSlidy>
              <div>
                {/*/////////////// GRAF ENCAMINHADOS NAO ACEITES  ///////////////*/}
                <ReqNotAccepted
                  filter_slider={this.state.filter_slider}
                  reqNotAccepted={this.state.reqNotAccepted}
                />
              </div>
              <div>
                {/*/////////////// GRAF PENDENTES  ///////////////*/}
                <PendingReq
                  filter_slider={this.state.filter_slider}
                  pendingReq={this.state.pendingReq}
                />
              </div>
              <div>
                {/*/////////////// GRAF STAND-BY  ///////////////*/}
                <StandByReq
                  filter_slider={this.state.filter_slider}
                  standByReq={this.state.standByReq}
                />
              </div>
            </ReactSlidy>
          </Grid>

          {/*/////////////// GRAF Leads sem Conversão  ///////////////*/}
          <Grid item xs={6} className="mt-2">
            <OtherCallsFilterForm
              filterDateOtherCalls={this.filterDateOtherCalls}
              countCallRegistsOtherCalls={this.countCallRegistsOtherCalls}
            />
            <CallRegistsOtherCalls
              filter_date_other_calls={this.state.filter_date_other_calls}
              callRegistsOtherCalls={this.state.callRegistsOtherCalls}
            />
          </Grid>

          <Grid item xs={12}>
            <h1 class="h3 statistics-title-3" id="admissoes">
              3. Admissões
            </h1>
          </Grid>

          {/*/////////////// GRAF ADMISSOES  ///////////////*/}
          {/*///// filtros activos: datas  ////*/}
          <Grid item xs={6}>
            <AdmissionsFilterForm
              filterDateAdmissions={this.filterDateAdmissions}
              countAdmissions={this.countAdmissions}
            />
            <div>
              <AdmissionsReq
                filter_date_admissions={this.state.filter_date_admissions}
                admissions={this.state.admissions}
              />
            </div>
          </Grid>

          {/*/// GRAF ADMISSOES FACE AOS ENCAMINHAMENTOS ///*/}
          {/*///// filtros activos: datas  ////*/}
          <Grid item xs={6}>
            <FollowupsVsAdmissionsFilterForm
              filterDateFollowupsVsAdmissions={
                this.filterDateFollowupsVsAdmissions
              }
              countFollowupsVsAdmissions={this.countFollowupsVsAdmissions}
            />
            <div>
              <FollowupsVsAdmissions
                filter_date_followups_vs_admissions={
                  this.state.filter_date_followups_vs_admissions
                }
                followupsVsAdmissions={this.state.followupsVsAdmissions}
              />
            </div>
          </Grid>

          {/*/// GRAF ADMISSOES PAGAS E NAO PAGAS ///*/}
          {/*///// filtros activos: datas  ////*/}
          <Grid item xs={6}>
            <AdmissionsPaidVsNotPaidFilterForm
              filterDateAdmissionsPaidVsNotPaid={
                this.filterDateAdmissionsPaidVsNotPaid
              }
              countAdmissionsPaidVsNotPaid={this.countAdmissionsPaidVsNotPaid}
            />
            <div>
              <AdmissionsPaidVsNotPaid
                filter_date_admissions_paid_vs_not_paid={
                  this.state.filter_date_admissions_paid_vs_not_paid
                }
                admissionsPaidVsNotPaid={this.state.admissionsPaidVsNotPaid}
              />
            </div>
          </Grid>

          <Grid item xs={6}></Grid>
        </Grid>
      </div>
    );
  }
}
export default withRouter(StatisticsView);
